/* eslint-disable import/no-extraneous-dependencies, camelcase, @typescript-eslint/naming-convention */
import React, { useState } from 'react';
import AddDocumentModal from './AddDocumentModal';
const DICT = {
    'documents.add_modal.title': 'Add Document',
    'documents.add_modal.intro': 'Upload a document for IPA to reference when answering questions.',
    'documents.add_modal.select_files': 'Click to upload',
    'documents.add_modal.select_files_suffix': 'or drag and drop',
    'documents.add_modal.drag_drop': 'PDF, DOCX, or TXT files',
    'documents.add_modal.accepted_types': 'Accepted file types: PDF, DOCX, TXT',
    'documents.add_modal.max_size': 'Maximum file size: 25MB',
    'documents.add_modal.cancel': 'Cancel',
    'documents.add_modal.upload': 'Upload'
};
const t = (key) => { var _a; return (_a = DICT[key]) !== null && _a !== void 0 ? _a : key; };
const meta = {
    title: 'Features/Settings/TenantKnowledgeBase/AddDocumentModal',
    component: AddDocumentModal,
    parameters: {
        layout: 'fullscreen'
    },
    args: {
        t,
        // eslint-disable-next-line no-alert
        onUpload: () => alert('Upload clicked')
    }
};
export default meta;
/**
 * Default open state — dropzone + Cancel/Upload actions.
 */
export const Default = {
    args: {
        isOpen: true
    },
    render: (args) => {
        const [isOpen, setIsOpen] = useState(true);
        return (
        // eslint-disable-next-line react/jsx-props-no-spreading
        React.createElement(AddDocumentModal, Object.assign({}, args, { isOpen: isOpen, onClose: () => setIsOpen(false) })));
    }
};
/**
 * Closed state — renders nothing (Modal returns null when isOpen is false).
 */
export const Closed = {
    args: {
        isOpen: false
    }
};
